// extracted by mini-css-extract-plugin
module.exports = {"JoinTeam":"JoinTeam_JoinTeam__2kzbN","JoinTeamForm":"JoinTeam_JoinTeamForm__18iE3"};